import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, Link } from "@tanstack/react-router";

import { Section, SectionHeader } from "@roqua/components/sections";

import { graphql } from "@/gql";
import { useVerifiedSession } from "@/session";
import { Button } from "@roqua/components/ui/button";
import { ErrorPage } from "@/components/ErrorPage";
import { toError } from "@/lib/utils";

const Query = graphql(/* GraphQL */ `
  query reportPage($respondentId: ID!, $reportId: ID!) {
    respondent(id: $respondentId) {
      report(id: $reportId) {
        id
        name
        createdAt
        pdfUrl
      }
    }
  }
`);

export const Route = createFileRoute("/portal/reports/$reportId")({
  component: RouteComponent,
  errorComponent: ({ error }) => <ErrorPage message={toError(error).message} />
});

function RouteComponent() {
  const { client, user } = useVerifiedSession();
  const { reportId } = Route.useParams();
  const {
    data: {
      respondent: { report },
    },
  } = useSuspenseQuery({
    queryKey: ["Report", reportId],
    queryFn: () =>
      client.request(Query, {
        respondentId: user.id,
        reportId: reportId,
      }),
  });

  return (
    <main className="">
      <Section variant="header">
        <SectionHeader
          header={report.name}
          buttons={
            <>
              <Button asChild className="rounded-full">
                <Link to="/portal">Terug</Link>
              </Button>
              {report.pdfUrl && (
                <Button asChild className="rounded-full">
                  <a href={report.pdfUrl} target="_blank">
                    Download
                  </a>
                </Button>
              )}
            </>
          }
        />
        <p>Aangemaakt op {report.createdAt}</p>
      </Section>

      <Section variant="content">
        {report.pdfUrl ? (
          <object
            data={report.pdfUrl}
            type="application/pdf"
            className="h-screen w-full"
          >
            Inline PDF not supported by your browser. Download the PDF using the
            button above instead.
          </object>
        ) : (
          <div>
            Van dit rapport ontbreekt de PDF in ons systeem, deze is momenteel
            niet inzichtelijk hierdoor.
          </div>
        )}
      </Section>
    </main>
  );
}
